define([
    'underscore',
], _ => [
    '$http',
    'configBasler',
    'LocaleService',
    '$q',
    'ContextService',
    'INFOTEXT_WHITELIST',
    ($http, configBasler, LocaleService, $q, ContextService, INFOTEXT_WHITELIST) => {
        const baseUrl = configBasler.cmsRestInterface.helpTextUrl;
        const lang = LocaleService.getCurrentLocale().substring(0, 2);
        const infotextWhitelist = INFOTEXT_WHITELIST ? INFOTEXT_WHITELIST.map(it => ({
            key: it.key,
            product: it.product.toLocaleLowerCase()
        })) : [];

        function makeRequest(url) {
            return $http({
                cache: true,
                method: 'GET',
                url,
                params: {
                    depth: 3,
                },
            });
        }

        function requestAndExtractText(product, key, textType) {
            return makeRequest(`${baseUrl}/${lang}/${product}/${textType}/${key}/main/0`)
                .then(response => _.find(response.data.properties, {name: 'text'}).values[0]);
        }

        function isInfoTextInWhitelist(key, product) {
            const lowercaseProduct = product && product.toLowerCase();
            return infotextWhitelist.some(item => item.key === key && item.product === lowercaseProduct)
        }

        return {
            getInfoText(product, key) {
                if (isInfoTextInWhitelist(key, product)) {
                    return requestAndExtractText(product, key, 'info');
                } else {
                    return Promise.reject(`key ${key} with product ${product} not defined`);
                }
            },
            getUWIssueText(product, key) {
                return makeRequest(`${baseUrl}/${lang}/${product}/issue/main`)
                    .then((response) => {
                        const wrapper = document.createElement('div');
                        // eslint-disable-next-line prefer-destructuring
                        wrapper.innerHTML = response.data.nodes[0].properties[0].values[0];

                        const children = Array.prototype.slice.call(wrapper.children);
                        const element = (key) ? children.find(div => div.id === key) : children.find(div => div.id === 'default');
                        return (element) ? element.innerText : $q.reject();
                    });
            },
            getSlogan(product, key) {
                return requestAndExtractText(product, key, 'slogan');
            },
            getFragment(product, key) {
                return requestAndExtractText(product, key, 'fragments');
            },
            getProductDocumentsLink() {
                return `${configBasler.magnoliaAssets.url + ContextService.getProductCode()}/${ContextService.getChannel()}/`;
            },
            isValidFragment(fragment) {
                const isValidProperty = (obj, key) => {
                    return Object.prototype.hasOwnProperty.call(obj, key) && (typeof obj[key] === 'string');
                };

                return fragment !== undefined &&
                    isValidProperty(fragment, 'overallTitleText') &&
                    Object.prototype.hasOwnProperty.call(fragment, 'cards') &&
                    Array.isArray(fragment.cards) && fragment.cards.length > 0 && fragment.cards
                        .every(card => (['titleText', 'imageUrl', 'paragraphText', 'buttonText', 'buttonUrl']
                            .every(prop => isValidProperty(card, prop)))
                        );
            }
        };
    },
]);



// WEBPACK FOOTER //
// ../common/js/src/edge/platform/basler/services/MagnoliaService.js